<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:header>
      <div class="d-flex justify-space-between w-100">
        <v-card-title class="screen-title">
          インターネットセキュリティアプライアンスポリシー設定
        </v-card-title>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="closeModal"
        >
          ×
        </button>
      </div>
    </template>
    <template v-if="isLoaded" v-slot:body>
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container fluid class="pa-0">
            <v-row justify="space-between" align="center" class="my-2">
              <v-radio-group
                inline
                density="comfortable"
                class="ml-2"
                v-model="direction"
                hide-details
              >
                <v-radio
                  value="accessPointToInternet"
                  label="アクセス拠点 → インターネット"
                />
                <v-radio
                  value="internetToAccessPoint"
                  label="インターネット → アクセス拠点"
                />
              </v-radio-group>

              <div class="d-flex mr-2 ga-1">
                <v-btn
                  color="primary"
                  @click="downloadConfig"
                  v-permission.config
                  >設定ダウンロード
                </v-btn>
                <v-btn color="primary" @click="uploadConfig" v-permission.config
                  >設定アップロード
                </v-btn>
              </div>
            </v-row>
            <template v-if="direction === 'accessPointToInternet'">
              <v-tabs hide-slider grow v-model="tabValue">
                <v-tab text="NAT(IP Masquerade)" value="NAT" />
                <v-tab text="UTM" value="UTM" />
              </v-tabs>
              <v-tabs-window
                v-model="tabValue"
                class="border-s-sm border-b-sm border-e-sm"
              >
                <v-tabs-window-item value="NAT">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyIPMasqueradeType4!.policyList.length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyAccessToInternetNAT"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="a2iNatTable.fields"
                    :items="policy.policyIPMasqueradeType4!.policyList"
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddressList)="{ value }">
                      <policy-src-address
                        :src-address="{ srcAddressList: value }"
                      />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddressList)="{ value }">
                      <policy-dst-address
                        :dst-address="{ dstAddressList: value }"
                      />
                    </template>

                    <!-- IP Pool -->
                    <template #cell(ipPoolList)="{ value }">
                      <policy-ip-pool :ip-pool-list="value" />
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
                <v-tabs-window-item value="UTM">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyUtmType4!.accessPointToInternetPolicyList
                          .length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyAccessToInternetUTM"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="a2iUtmTable.fields"
                    :items="
                      policy.policyUtmType4!.accessPointToInternetPolicyList
                    "
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddress)="{ value }">
                      <policy-src-address :src-address="value" />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddress)="{ value }">
                      <policy-dst-address :dst-address="value" />
                    </template>

                    <!-- サービス -->
                    <template #cell(service)="{ item }">
                      <policy-service
                        :service-option="item.serviceOption"
                        :default-service-list="item.defaultServiceList"
                        :custom-service-list="item.customServiceList"
                      />
                    </template>

                    <!-- プロファイル -->
                    <template #cell(profile)="{ value }">
                      <policy-profile :profile="value" />
                    </template>

                    <!-- アクション -->
                    <template #cell(actionType)="{ value }">
                      {{ $filter.enumTo(value, "allow_deny") }}
                    </template>

                    <!-- ログ出力 -->
                    <template #cell(isLogOutput)="{ value }">
                      {{ $filter.enumTo(value, "on_off") }}
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
              </v-tabs-window>
            </template>
            <template v-if="direction === 'internetToAccessPoint'">
              <v-tabs hide-slider grow v-model="tabValue">
                <v-tab text="NAT(IP Forwarding)" value="NAT" />
                <v-tab text="UTM" value="UTM" />
              </v-tabs>
              <v-tabs-window
                v-model="tabValue"
                class="border-s-sm border-b-sm border-e-sm"
              >
                <v-tabs-window-item value="NAT">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyNatType4!.policyList.length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyInternetToAccessNAT"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="i2aNatTable.fields"
                    :items="policy.policyNatType4!.policyList"
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="() => undefined"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddressList)="{ value }">
                      <policy-src-address
                        :src-address="{ srcAddressList: value }"
                      />
                    </template>

                    <!-- IPマッピング -->
                    <template #cell(ipMapping)="{ value }">
                      {{ value.ipMappingName }}
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
                <v-tabs-window-item value="UTM">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyUtmType4!.internetToAccessPointPolicyList
                          .length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyInternetToAccessUTM"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="i2aUtmTable.fields"
                    :items="
                      policy.policyUtmType4!.internetToAccessPointPolicyList
                    "
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddress)="{ value }">
                      <policy-src-address :src-address="value" />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddress)="{ value }">
                      <policy-dst-address :dst-address="value" />
                    </template>

                    <!-- サービス -->
                    <template #cell(service)="{ item }">
                      <policy-service
                        :service-option="item.serviceOption"
                        :default-service-list="item.defaultServiceList"
                        :custom-service-list="item.customServiceList"
                      />
                    </template>

                    <!-- プロファイル -->
                    <template #cell(profile)="{ value }">
                      <policy-profile :profile="value" />
                    </template>

                    <!-- アクション -->
                    <template #cell(actionType)="{ value }">
                      {{ $filter.enumTo(value, "allow_deny") }}
                    </template>

                    <!-- ログ出力 -->
                    <template #cell(isLogOutput)="{ value }">
                      {{ $filter.enumTo(value, "on_off") }}
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
              </v-tabs-window>
            </template>
          </v-container>
        </div>
        <v-alert v-if="!!uploadAlert" class="my-4" :text="uploadAlert" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              variant="flat"
              color="primary"
              @click="putPolicy"
              v-permission.config
            >
              ポリシー設定反映
            </v-btn>
            <v-btn variant="outlined" color="primary" @click="closeModal"
              >キャンセル
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  GetDstAddress1,
  GetDstAddress2,
  GetPolicy,
  GetPolicyType4,
  GetSrcAddress1,
  GetSrcAddress2,
  PutDstAddress1,
  PutDstAddress2,
  PutPolicyType4,
  PutSrcAddress1,
  PutSrcAddress2,
} from "@/apis/NwPolicyApi";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import PolicyDstAddress from "@/components/policy/PolicyDstAddress.vue";
import PolicyService from "@/components/policy/PolicyService.vue";
import PolicyProfile from "@/components/policy/PolicyProfile.vue";
import type { Type4Service } from "@/apis/ContractChangeType4Api";
import PolicyIpPool from "@/components/policy/PolicyIpPool.vue";
import { UploadError } from "@/services/ConfigDownloadService";
import type { AppTableHeader } from "@/components/AppTable.vue";
import InternetType4PolicyRuleUtmViewRD from "@/modals/applianceContractSetting/type4/policy/utm/InternetType4PolicyRuleUtmViewRD.vue";
import InternetType4PolicyRuleIpMasqViewRD from "@/modals/applianceContractSetting/type4/policy/ipMasquerade/InternetType4PolicyRuleIpMasqViewRD.vue";
import InternetType4PolicyRuleDestNatViewRD from "@/modals/applianceContractSetting/type4/policy/ipForwarding/InternetType4PolicyRuleDestNatViewRD.vue";
import InternetType4PolicyUtmConfirm from "@/modals/applianceContractSetting/type4/policy/InternetType4PolicyUtmConfirm.vue";
import { VueFinalModal } from "vue-final-modal";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

export default defineComponent({
  name: "InternetType4PolicyUtmList",
  components: {
    PolicyIpPool,
    PolicyProfile,
    PolicyService,
    PolicyDstAddress,
    PolicySrcAddress,
  },
  props: {
    /** Type4Id. 主キー */
    type4Id: {
      type: String as PropType<string>,
      required: true,
    },
    /** サービスメニュー(インターネットType4) */
    type4Service: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "UTM" as "NAT" | "UTM",
      direction: "accessPointToInternet",
      policy: {} as GetPolicyType4,
      originalPolicy: {} as GetPolicyType4,
      i2aNatTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddressList", title: "送信元アドレス", width: "150px" },
          { key: "ipMapping", title: "IPマッピング", width: "200px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      i2aUtmTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddress", title: "送信元アドレス", width: "150px" },
          { key: "dstAddress", title: "宛先アドレス", width: "150px" },
          { key: "service", title: "サービス", width: "15%" },
          { key: "profile", title: "プロファイル", width: "20%" },
          { key: "actionType", title: "アクション", width: "80px" },
          { key: "isLogOutput", title: "ログ出力", width: "70px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      a2iNatTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddressList", title: "送信元アドレス", width: "150px" },
          { key: "dstAddressList", title: "宛先アドレス", width: "150px" },
          { key: "ipPoolList", title: "IP Pool", width: "150px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      a2iUtmTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddress", title: "送信元アドレス", width: "150px" },
          { key: "dstAddress", title: "宛先アドレス", width: "150px" },
          { key: "service", title: "サービス", width: "15%" },
          { key: "profile", title: "プロファイル", width: "20%" },
          { key: "actionType", title: "アクション", width: "80px" },
          { key: "isLogOutput", title: "ログ出力", width: "70px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      uploadAlert: null as string | null,
      isLoaded: false,
    };
  },
  async mounted() {
    this.policy = await this.$api.nwPolicy.getType4Policies(
      this.type4Id,
      "UTM_IPMASQUERADE_NAT"
    );
    this.originalPolicy = cloneDeep(this.policy);
    this.isLoaded = true;
  },
  computed: {
    /** 変更があるかどうかを判定（policyKeyIdは比較から除外） */
    hasChanges(): boolean {
      const normalize = (p: GetPolicyType4) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { policyKeyId, ...rest } = p ?? ({} as GetPolicyType4);
        return rest;
      };
      return !isEqual(normalize(this.policy), normalize(this.originalPolicy));
    },
  },
  methods: {
    /** モーダルを閉じる処理（変更がある場合は確認ダイアログを表示） */
    async closeModal(): Promise<void> {
      if (!this.hasChanges) {
        (
          this.$refs.modal as typeof VueFinalModal & { cancel: () => void }
        ).cancel();
        return;
      }
      try {
        await this.$confirm("変更を破棄してキャンセルします、よろしいですか？");
        (
          this.$refs.modal as typeof VueFinalModal & { cancel: () => void }
        ).cancel();
      } catch {
        return;
      }
    },
    tdClass(field: AppTableHeader<unknown>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
    /** ポリシー設定反映 */
    async putPolicy() {
      this.uploadAlert = null;
      // ポリシー画面からオブジェクトを追加するとkeyIdを更新する必要があるため以下で再取得
      this.isLoaded = false;
      this.policy.policyKeyId = (
        await this.$api.nwPolicy.getType4Policies(
          this.type4Id,
          "UTM_IPMASQUERADE_NAT"
        )
      ).policyKeyId;
      this.isLoaded = true;
      await this.$modal.show(InternetType4PolicyUtmConfirm, {
        type4Policy: this.policy,
        type4Service: this.type4Service,
      });
      await this.$api.nwPolicy.putType4Policies(
        this.type4Id,
        get2putPolicy(this.policy),
        "UTM_IPMASQUERADE_NAT"
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 設定ダウンロード */
    downloadConfig() {
      this.$service.configDownload.downloadInternetType4Policy(
        this.type4Id,
        "UTM",
        this.policy
      );
    },

    /** 設定アップロード */
    async uploadConfig() {
      try {
        const uploadPolicy =
          await this.$service.configDownload.uploadInternetType4Policy(
            this.type4Id,
            "UTM",
            this.policy
          );
        this.uploadAlert = null;
        await this.$confirm(
          "ポリシー設定を上書きします。設定反映していない設定は破棄されます。よろしいですか？"
        );
        setNewPolicyObjectIdToNull(uploadPolicy, this.originalPolicy);
        this.policy = uploadPolicy;
      } catch (e) {
        this.uploadAlert = (e as UploadError).message;
      }
    },

    /** インターネット→アクセス拠点 NATのルールを編集 */
    async editPolicyInternetToAccessNAT() {
      this.uploadAlert = null;
      this.policy.policyNatType4!.policyList = await this.$modal.show(
        InternetType4PolicyRuleDestNatViewRD,
        {
          type4Id: this.type4Id,
          policyList: this.policy.policyNatType4!.policyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        }
      );
    },

    /** インターネット→アクセス拠点 UTMのルールを編集 */
    async editPolicyInternetToAccessUTM() {
      this.uploadAlert = null;
      this.policy.policyUtmType4!.internetToAccessPointPolicyList =
        await this.$modal.show(InternetType4PolicyRuleUtmViewRD, {
          type4Id: this.type4Id,
          from: "INTERNET",
          policyList:
            this.policy.policyUtmType4!.internetToAccessPointPolicyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        });
    },

    /** アクセス拠点→インターネットNATのルールを編集 */
    async editPolicyAccessToInternetNAT() {
      this.uploadAlert = null;
      this.policy.policyIPMasqueradeType4!.policyList = await this.$modal.show(
        InternetType4PolicyRuleIpMasqViewRD,
        {
          type4Id: this.type4Id,
          policyList: this.policy.policyIPMasqueradeType4!.policyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        }
      );
    },

    /** アクセス拠点→インターネットUTMのルールを編集 */
    async editPolicyAccessToInternetUTM() {
      this.uploadAlert = null;
      this.policy.policyUtmType4!.accessPointToInternetPolicyList =
        await this.$modal.show(InternetType4PolicyRuleUtmViewRD, {
          type4Id: this.type4Id,
          from: "ACCESS_POINT",
          policyList:
            this.policy.policyUtmType4!.accessPointToInternetPolicyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        });
    },
    /**
     * ポリシーテーブルのtrクラス.
     * 編集不可デフォルトポリシーの場合は特定のクラスを返す
     */
    policyRowClass(
      item: Pick<GetPolicy, "policyCategoryInfo">
    ): string[] | undefined {
      return item.policyCategoryInfo === "UNEDITABLE_DEFAULT_POLICY"
        ? ["gray-out"]
        : undefined;
    },
  },
});

/** type4ポリシーGETをPUT用のポリシーに変換 */
export function get2putPolicy(type4policy: GetPolicyType4): PutPolicyType4 {
  const toSrcAddress1 = (src: GetSrcAddress1): PutSrcAddress1 => ({
    srcAddressList: src.srcAddressList.map((e) => e.ipAddressId!),
    srcFqdnList: src.srcFqdnList.map((e) => e.fqdnId),
    srcCountryList: src.srcCountryList.map((e) => e.countrySeq),
  });
  const toDstAddress1 = (dst: GetDstAddress1): PutDstAddress1 => ({
    dstAddressList: dst.dstAddressList.map((e) => e.ipAddressId!),
  });
  const toSrcAddress2 = (src: GetSrcAddress2): PutSrcAddress2 => ({
    srcAddressList: src.srcAddressList.map((e) => e.ipAddressId!),
  });
  const toDstAddress2 = (dst: GetDstAddress2): PutDstAddress2 => ({
    dstAddressList: dst.dstAddressList.map((e) => e.ipAddressId!),
    dstFqdnList: dst.dstFqdnList.map((e) => e.fqdnId),
    dstCountryList: dst.dstCountryList.map((e) => e.countrySeq),
  });
  const toDefaultService = (s: GetPolicy["defaultServiceList"]): string[] =>
    s.map((e) => e.serviceSeq);
  const toCustomService = (s: GetPolicy["customServiceList"]): string[] =>
    s.map((e) => e.customServiceSeq);

  return {
    policyUtmType4: type4policy.policyUtmType4
      ? {
          internetToAccessPointPolicyList:
            type4policy.policyUtmType4.internetToAccessPointPolicyList
              .filter(
                (e) => e.policyCategoryInfo !== "UNEDITABLE_DEFAULT_POLICY"
              )
              .map((policy) => ({
                ...policy,
                srcAddress: toSrcAddress1(policy.srcAddress),
                dstAddress: toDstAddress1(policy.dstAddress),
                defaultServiceList: toDefaultService(policy.defaultServiceList),
                customServiceList: toCustomService(policy.customServiceList),
              })),
          accessPointToInternetPolicyList:
            type4policy.policyUtmType4.accessPointToInternetPolicyList
              .filter(
                (e) => e.policyCategoryInfo !== "UNEDITABLE_DEFAULT_POLICY"
              )
              .map((policy) => ({
                ...policy,
                srcAddress: toSrcAddress2(policy.srcAddress),
                dstAddress: toDstAddress2(policy.dstAddress),
                defaultServiceList: toDefaultService(policy.defaultServiceList),
                customServiceList: toCustomService(policy.customServiceList),
              })),
        }
      : null,
    policyIfwType4: type4policy.policyIfwType4
      ? {
          internetToAccessPointPolicyList:
            type4policy.policyIfwType4.internetToAccessPointPolicyList
              .filter(
                (e) => e.policyCategoryInfo !== "UNEDITABLE_DEFAULT_POLICY"
              )
              .map((policy) => ({
                ...policy,
                srcAddress: toSrcAddress1(policy.srcAddress),
                dstAddress: toDstAddress1(policy.dstAddress),
                defaultServiceList: toDefaultService(policy.defaultServiceList),
                customServiceList: toCustomService(policy.customServiceList),
              })),
          accessPointToInternetPolicyList:
            type4policy.policyIfwType4.accessPointToInternetPolicyList
              .filter(
                (e) => e.policyCategoryInfo !== "UNEDITABLE_DEFAULT_POLICY"
              )
              .map((policy) => ({
                ...policy,
                srcAddress: toSrcAddress2(policy.srcAddress),
                dstAddress: toDstAddress2(policy.dstAddress),
                defaultServiceList: toDefaultService(policy.defaultServiceList),
                customServiceList: toCustomService(policy.customServiceList),
              })),
        }
      : null,
    policyIPMasqueradeType4: type4policy.policyIPMasqueradeType4
      ? {
          policyList: type4policy.policyIPMasqueradeType4.policyList
            .filter((e) => e.policyCategoryInfo !== "UNEDITABLE_DEFAULT_POLICY")
            .map((policy) => ({
              ...policy,
              srcAddressList: policy.srcAddressList.map((e) => e.ipAddressId!),
              dstAddressList: policy.dstAddressList.map((e) => e.ipAddressId!),
              ipPoolList: policy.ipPoolList.map((e) => e.ipPoolSeq),
            })),
        }
      : null,
    policyNatType4: type4policy.policyNatType4
      ? {
          policyList: type4policy.policyNatType4.policyList.map((policy) => ({
            ...policy,
            srcAddressList: policy.srcAddressList.map((e) => e.ipAddressId!),
          })),
        }
      : null,
    policyKeyId: type4policy.policyKeyId,
  };
}
/**
 * uploadPolicy の各リストで
 * • originalPolicy に存在しない policyId → policyObjectId = null
 * • originalPolicy と両方に存在する policyId → original の policyObjectId を復元
 */
export function setNewPolicyObjectIdToNull(
  uploadPolicy: GetPolicyType4,
  originalPolicy: GetPolicyType4
) {
  // policyList を扱う共通ロジック
  const checkAndNullify = (
    uploadList: { policyId: string; policyObjectId: string | null }[] = [],
    originalList: { policyId: string; policyObjectId: string | null }[] = []
  ) => {
    const originalMap = new Map(
      originalList.map((o) => [o.policyId, o.policyObjectId])
    );
    uploadList.forEach((u) => {
      u.policyObjectId = originalMap.has(u.policyId)
        ? originalMap.get(u.policyId)! // 既存 → 復元
        : null; // 新規 → null
    });
  };
  // UTM
  checkAndNullify(
    uploadPolicy.policyUtmType4?.internetToAccessPointPolicyList,
    originalPolicy.policyUtmType4?.internetToAccessPointPolicyList
  );
  checkAndNullify(
    uploadPolicy.policyUtmType4?.accessPointToInternetPolicyList,
    originalPolicy.policyUtmType4?.accessPointToInternetPolicyList
  );

  // IFW
  checkAndNullify(
    uploadPolicy.policyIfwType4?.internetToAccessPointPolicyList,
    originalPolicy.policyIfwType4?.internetToAccessPointPolicyList
  );
  checkAndNullify(
    uploadPolicy.policyIfwType4?.accessPointToInternetPolicyList,
    originalPolicy.policyIfwType4?.accessPointToInternetPolicyList
  );

  // Masquerade
  checkAndNullify(
    uploadPolicy.policyIPMasqueradeType4?.policyList,
    originalPolicy.policyIPMasqueradeType4?.policyList
  );

  // NAT
  checkAndNullify(
    uploadPolicy.policyNatType4?.policyList,
    originalPolicy.policyNatType4?.policyList
  );
}
</script>
<style lang="scss" scoped>
:deep(th) {
  font-size: 90%;
}
</style>
